import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'
import { CarouselProvider, Slider } from 'pure-react-carousel'

export const Container = styled.section`
    width: inherit;
    overflow: hidden;
    padding: 0.5rem 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const PopularFilterListingsWrapper = styled.div`
    display: flex;
    grid-template-columns: repeat(2, 1fr);
    gap: ${props => props.theme.spacing.medium};
    margin-top: 1rem;
`

export const SliderContainer = styled.div`
    position: ${props => props.theme.style.position.relative};
    max-width: fit-content;
    overflow: hidden;
    margin-top: 1rem;
`

export const StyledCarouselProvider = styled(CarouselProvider)<{ margin?: string; center?: boolean }>`
    width: 100%;
    margin: ${({ margin }) => (!!margin ? margin : 0)};
    li {
        list-style: none;
    }
    ${({ center }) =>
        center
            ? `& > .carousel__slider {
            padding-left: 1rem;
            padding-right: 1rem;

            @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                padding: 0 1.5rem;
            }
        }`
            : ''}
`

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ $transitionTime }) => css`
        padding: 0;
        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : `0.5s`};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }
    `,
)
